import React from 'react';
import { Switch } from 'antd';

import { useIsDisabledForRole } from './ButtonWithRole';
import type { UserRole } from '@prerender/prerender-shared/FE';

type SettingsToggleProps = {
  disabledFor?: UserRole | readonly UserRole[];
} & React.ComponentProps<typeof Switch>;

function SettingsToggle({ disabledFor, ...props }: SettingsToggleProps) {
  const disabledForRole = useIsDisabledForRole(disabledFor);
  const disabled = disabledForRole || props.disabled;

  return <Switch {...props} disabled={disabled} />;
}

export default SettingsToggle;
